// extracted by mini-css-extract-plugin
export default {"t":"style_t__67JTy","s":"style_s__9PW7J","s2":"style_s2__x+s9E"};